// n8n webhook endpoints — replace these placeholders with your real n8n URLs.
// Every response is expected to include a numeric `credits` field so the UI
// can show the current balance. If it's missing → the frontend shows "Error".
export const WEBHOOKS = {
  register: "https://n8n.nexeronai.com/webhook/register",   // POST { email, password }                       → { token, credits, email }
  recovery: "https://n8n.nexeronai.com/webhook/recovery",   // POST { email }                                 → { success }
  login: "https://n8n.nexeronai.com/webhook/login",      // POST { email, password }                       → { token, credits, email }
  me: "https://n8n.nexeronai.com/webhook/me",         // GET  (Authorization: Bearer)                    → { email, credits }
  generate: "https://n8n.nexeronai.com/webhook/generate",   // POST multipart image + model/res/format/gender → { imageUrl, credits }
  gallery: "https://n8n.nexeronai.com/webhook/gallery",    // GET                                             → [{ id, url, createdAt, model }]
  checkout: "https://n8n.nexeronai.com/webhook/checkout",   // POST { pack }                                   → { checkoutUrl }
  packs: "https://n8n.nexeronai.com/webhook/packs",     // GET                                             → [{ id, name, description, price, credits }]
  refresh:"https://n8n.nexeronai.com/webhook/refresh",  // POST { refresh_token } → { token }                         → { token, credits }
};

// Simulated response body — used while WEBHOOKS.* still equal "url_webhook".
// Includes a `credits` field so the demo behaves the same as a real n8n reply.
function simulatedResponse({ credits = 3 } = {}) {
  return { ok: true, simulated: true, credits };
}

export async function postJson(url, body, token) {
  if (url === "url_webhook") {
    await new Promise((r) => setTimeout(r, 900));
    return simulatedResponse({ credits: 3 });
  }

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    return {
      error: true,
      message: data.message || `Error del servidor (${res.status})`,
      credits: data.credits,
    };
  }

  return data;
}

export async function getJson(url, token) {
  if (url === "url_webhook") {
    await new Promise((r) => setTimeout(r, 600));
    return simulatedResponse({ credits: 3 });
  }


  let res = await fetch(url, {
    
    method: "GET",
    headers: token 
      ? { Authorization: `Bearer ${token}` } 
      : {},
  });

  console.log(" Webhook llamado:", url);
  console.log(" Status recibido:", res.status);
  console.log(" Respuesta headers:", res.headers);


  // Token caducado
  if (res.status === 401) {

    console.log("🔄 Token expirado. Intentando refresh...");

    const session = JSON.parse(
      localStorage.getItem("nexeron_session")
    );
    console.log("SESSION:", session);
    
    const refreshToken = session?.refreshToken;

    if (!refreshToken) {
      throw new Error("No hay refresh token");
    }

    console.log("🚀 Llamando webhook refresh:");
    console.log("📦 Enviando refresh token");

    const refreshRes = await fetch(WEBHOOKS.refresh, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refresh_token: refreshToken,
      }),
    });


    if (!refreshRes.ok) {
      throw new Error("No se pudo refrescar el token");
    }


    const refreshData = await refreshRes.json();


    const newToken = refreshData.token;


    if (!newToken) {
      throw new Error("Refresh sin token nuevo");
    }


    // Actualizar sesión completa
    if (session) {

      session.token = newToken;

      if (refreshData.refresh_token) {
        session.refreshToken = refreshData.refresh_token;
      }

      if (typeof refreshData.credits === "number") {
        session.credits = refreshData.credits;
      }


      localStorage.setItem(
        "nexeron_session",
        JSON.stringify(session)
      );

    }

    localStorage.setItem(
      "token",
      newToken
    );

    window.dispatchEvent(
      new Event("token-refreshed")
    );


    // Repetir petición original con token nuevo
    res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${newToken}`,
      },
    });

  }


  if (!res.ok) {
    throw new Error(`Request failed: ${res.status}`);
  }


  return res.json();
}

export async function postForm(url, formData, token) {
  if (url === "url_webhook") {
    await new Promise((r) => setTimeout(r, 1400));
    // Simulated generate response — assume 1 credit was consumed (cost is echoed back to app).
    const cost = Number(formData.get?.("cost")) || 1;
    return { ok: true, simulated: true, credits: null, simulatedCost: cost };
  }
  const res = await fetch(url, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res.json();
}

/**
 * Extract the `credits` value from an n8n response.
 * Returns:
 *   { credits: number }  when the response contains a numeric credits field
 *   { credits: null }    when the field is missing / invalid  → UI must show "Error"
 */
export function readCredits(response) {
  if (response && typeof response.credits === "number" && Number.isFinite(response.credits)) {
    return { credits: response.credits };
  }
  return { credits: null };
}